import { Component } from '@angular/core';
import { ReportName } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { BuyerInsightsService } from './insights.service';

@Component({
    selector: 'supply-chain-direct-buyer-insights-epa',
    template: `
        <iframe
            [src]="(iframeProps$ | async)?.url"
            width="100%"
            [height]="(iframeProps$ | async)?.heightPx + 'px'"
            [style]="{
                border: 'none'
            }"
        ></iframe>
    `
})
export class BuyerInsightsEarlyPayAdoptionComponent {
    public iframeProps$ = this._insightsService.getIFrameProps$(
        ReportName.EARLY_PAY_ADOPTION,
        1100,
        780
    );

    constructor(private _insightsService: BuyerInsightsService) {}
}
